export const isEndOfElemReached = (elem: Element, maxPercentOfPassedScrollDistance: number): boolean => {
  const scrollTop = elem.scrollTop + elem.clientHeight;
  const maxScroll = elem.scrollHeight;
  return (scrollTop / maxScroll) * 100 > maxPercentOfPassedScrollDistance;
};
